export enum MedicalCheckupListChangeType {
    Created = 'Created',
    Updated = 'Updated',
    Removed = 'Removed',
}
